import React from "react";
import PropTypes from "prop-types";
import ServiceLink from "./ServiceLink";

const INFRA_SERVICES = new Set([
  "nats", "nats-box", "mqtt", "nginx", "forge", "shuttle",
  "clickhouse", "prometheus", "loki", "promtail", "grafana",
]);

function getConduitContainers(dockerContainers) {
  if (!dockerContainers?.length) return [];

  const conduits = dockerContainers
    .filter((c) => !INFRA_SERVICES.has(c.Service))
    .map((c) => {
      const publishedPort = c.Publishers?.find((p) => p.TargetPort === 8080)?.PublishedPort || 8080;
      return { serviceName: c.Service, port: publishedPort };
    });

  if (conduits.length > 0) return conduits;
  return [{ serviceName: "conduit", port: 8080 }];
}

const ServiceLinksSection = ({ publicIp, isServiceHealthy, dockerContainers }) => {
  const conduitContainers = getConduitContainers(dockerContainers);

  return (
    <div className="service-links">
      <h3>Service URLs</h3>
      <div className="links-grid">
        {conduitContainers.map((c) => (
          <ServiceLink
            key={c.serviceName}
            icon="🔌"
            title={`${c.serviceName} API`}
            url="/swagger/"
            port={c.port}
            serviceName={c.serviceName}
            publicIp={publicIp}
            isHealthy={isServiceHealthy(c.serviceName)}
          />
        ))}
        <ServiceLink
          icon="⚡"
          title="Forge API"
          url="/swagger/"
          port={8081}
          serviceName="forge"
          publicIp={publicIp}
          isHealthy={isServiceHealthy("forge")}
        />
        <ServiceLink
          icon="🌍"
          title="UI Dashboard"
          url=""
          port={80}
          serviceName="nginx"
          publicIp={publicIp}
          isHealthy={isServiceHealthy("nginx")}
        />
        <ServiceLink
          icon="📊"
          title="NATS Monitoring"
          url=""
          port={8222}
          serviceName="nats"
          publicIp={publicIp}
          isHealthy={isServiceHealthy("nats")}
        />
        <ServiceLink
          icon="📈"
          title="Grafana Dashboard"
          url=""
          port={3000}
          serviceName="grafana"
          publicIp={publicIp}
          isHealthy={isServiceHealthy("grafana")}
        />
        <ServiceLink
          icon="🔍"
          title="Prometheus"
          url=""
          port={9090}
          serviceName="prometheus"
          publicIp={publicIp}
          isHealthy={isServiceHealthy("prometheus")}
        />
        <ServiceLink
          icon="💾"
          title="ClickHouse"
          url="/play"
          port={8123}
          serviceName="clickhouse"
          publicIp={publicIp}
          isHealthy={isServiceHealthy("clickhouse")}
        />
      </div>
    </div>
  );
};

ServiceLinksSection.propTypes = {
  publicIp: PropTypes.string.isRequired,
  isServiceHealthy: PropTypes.func.isRequired,
  dockerContainers: PropTypes.array,
};

ServiceLinksSection.defaultProps = {
  dockerContainers: [],
};

export default ServiceLinksSection;
